import Axios from "axios";
import { useEffect, useState } from "react";

export const useDataHook = ({ path, defaultValue = {} }) => {
  const [value, setValue] = useState(defaultValue);
  const [loading, setLoading] = useState(defaultValue);
  useEffect(() => {
    if (!(path instanceof Function ? path() : path)) return;
    setLoading(true);
    //Change for server api address
    const url =
      process.env.REACT_APP_API2_URL +
      (path instanceof Function ? path() : path);
    Axios.get(url)
      .then((response) => response.data)
      .then((value) => {
        setLoading(false);
        setValue(value);
      });
  }, [path]);

  return {
    value,
    loading,
  };
};
